var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3249 18L15.6821 12M9.96781 12L3.32499 18M2.82495 7L10.9899 12.7154C11.651 13.1783 11.9816 13.4097 12.3412 13.4993C12.6588 13.5785 12.9911 13.5785 13.3087 13.4993C13.6683 13.4097 13.9989 13.1783 14.66 12.7154L22.825 7M7.62495 20H18.025C19.7051 20 20.5452 20 21.1869 19.673C21.7514 19.3854 22.2104 18.9265 22.498 18.362C22.825 17.7202 22.825 16.8802 22.825 15.2V8.8C22.825 7.11984 22.825 6.27976 22.498 5.63803C22.2104 5.07354 21.7514 4.6146 21.1869 4.32698C20.5452 4 19.7051 4 18.025 4H7.62495C5.94479 4 5.10471 4 4.46298 4.32698C3.89849 4.6146 3.43955 5.07354 3.15193 5.63803C2.82495 6.27976 2.82495 7.11984 2.82495 8.8V15.2C2.82495 16.8802 2.82495 17.7202 3.15193 18.362C3.43955 18.9265 3.89849 19.3854 4.46298 19.673C5.10471 20 5.94479 20 7.62495 20Z",
    stroke: "#000025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail02);
export default __webpack_public_path__ + "static/media/mail-02.8f0baf743d6d0e597be0ee688307a3ea.svg";
export { ForwardRef as ReactComponent };